import Joyride, { CallBackProps, Step } from "react-joyride";

import GuideTourContext from "../context/GuideTourContext";

import CustomTooltip from "./custom-tooltip";
import React from "react";

type TourStep = Pick<Step, "target" | "content" | "disableBeacon">;

interface GuidedTourProps {
  runTour: boolean;
  steps: TourStep[];
  styles?: { options: any };
  isSpotlightClicks?: boolean;
  tourStepIndex: number;
  disableNextBtn?: boolean;
  hideBackBtn?: boolean;
  setTourStepIndex: React.Dispatch<React.SetStateAction<number>>;
  setRunTour: React.Dispatch<React.SetStateAction<boolean>>;
  tourCallBack?: (data: CallBackProps) => void;
}

const GuidedTour = ({
  runTour,
  steps,
  styles,
  isSpotlightClicks,
  tourStepIndex,
  disableNextBtn = false,
  hideBackBtn = false,
  setTourStepIndex,
  setRunTour,
  tourCallBack,
}: GuidedTourProps) => {
  const defaultTourCallBack = (data: CallBackProps) => {
    const { action, index, status, type } = data;
    console.log(action, index, status, type);

    if (type === "step:after" && action === "prev") {
      setTourStepIndex(index - 1);
    }

    if (type === "step:after" && action === "next") {
      setTourStepIndex(index + 1);
    }
    if (status === "finished" || status === "skipped") {
      setTourStepIndex(0);
      setRunTour(false);
    }
  };
  return (
    <GuideTourContext.Provider value={{ disableNextBtn, hideBackBtn }}>
      <Joyride
        steps={steps}
        run={runTour}
        stepIndex={tourStepIndex}
        styles={styles}
        continuous
        disableOverlayClose
        scrollOffset={100}
        spotlightPadding={10}
        spotlightClicks={isSpotlightClicks ?? false}
        scrollToFirstStep
        showSkipButton
        tooltipComponent={CustomTooltip}
        callback={tourCallBack ? tourCallBack : defaultTourCallBack}
      />
    </GuideTourContext.Provider>
  );
};

export default GuidedTour;
